import { CopyIcon } from "@chakra-ui/icons";
import {
  Flex,
  Heading,
  IconButton,
  Skeleton,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { handleCopyValue } from "utils";

interface APIKeysViewProps {
  apiKey?: string;
  audienceApiKey?: string;
}

const APIKeysView = (props: APIKeysViewProps) => {
  const { apiKey, audienceApiKey } = props;

  const toast = useToast();
  const bgHover = useColorModeValue(
    { bg: "brand.100" },
    { bg: "whiteAlpha.50" }
  );

  return (
    <Flex
      p={4}
      flexDir={"column"}
      mt={8}
      borderRadius={"16"}
      backgroundColor="white"
    >
      <Heading fontSize={"xl"}>API Keys</Heading>
      <Flex mt={4}>
        <Flex
          flexDir={"column"}
          borderRadius={"16"}
          backgroundColor={"gray.100"}
          p={4}
          mr={4}
          _hover={{ ...bgHover, cursor: "pointer" }}
          onClick={() => {
            handleCopyValue(apiKey);
            toast({
              title: "Copied to clipboard.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
          }}
        >
          <Text fontWeight={"semibold"} color={"gray.800"}>
            API Key
          </Text>
          <Text mt={2} fontSize={"md"} color={"gray.600"}>
            {typeof apiKey === "string" ? apiKey : <Skeleton h={6} w={64} />}
            <IconButton ml={2} aria-label="Copy API Key" icon={<CopyIcon />} />
          </Text>
        </Flex>
        <Flex
          flexDir={"column"}
          borderRadius={"16"}
          backgroundColor={"gray.100"}
          p={4}
          _hover={{ ...bgHover, cursor: "pointer" }}
          onClick={() => {
            handleCopyValue(audienceApiKey);
            toast({
              title: "Copied to clipboard.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
          }}
        >
          <Text fontWeight={"semibold"} color={"gray.800"}>
            Audience API Key
          </Text>
          <Text mt={2} fontSize={"md"} color={"gray.600"}>
            {typeof audienceApiKey === "string" ? (
              audienceApiKey
            ) : (
              <Skeleton h={6} w={64} />
            )}
            <IconButton ml={2} aria-label="Copy API Key" icon={<CopyIcon />} />
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default APIKeysView;
